export default __webpack_public_path__ + "static/media/nepal_chw.adfa2b7d.jpg";